// @mui material components
import {createTheme} from "@mui/material/styles";
// import Fade from "@mui/material/Fade";
// VoK MUI base styles
import colors from "app/assets/theme-dark/base/colors";
import breakpoints from "app/assets/theme-dark/base/breakpoints";
import typography from "app/assets/theme-dark/base/typography";
import boxShadows from "app/assets/theme-dark/base/boxShadows";
import borders from "app/assets/theme-dark/base/borders";
import globals from "app/assets/theme-dark/base/globals";

// VoK MUI helper functions
import boxShadow from "app/assets/theme-dark/functions/boxShadow";
import hexToRgb from "app/assets/theme-dark/functions/hexToRgb";
import linearGradient from "app/assets/theme-dark/functions/linearGradient";
import pxToRem from "app/assets/theme-dark/functions/pxToRem";
import rgba from "app/assets/theme-dark/functions/rgba";

// VoK MUI components base styles for @mui material components
import sidenav from "app/assets/theme-dark/components/sidenav";
import list from "app/assets/theme-dark/components/list";
import listItem from "app/assets/theme-dark/components/list/listItem";
import listItemText from "app/assets/theme-dark/components/list/listItemText";
import card from "app/assets/theme-dark/components/card";
import cardMedia from "app/assets/theme-dark/components/card/cardMedia";
import cardContent from "app/assets/theme-dark/components/card/cardContent";
import button from "app/assets/theme-dark/components/button";
import iconButton from "app/assets/theme-dark/components/iconButton";
import inputBase from "app/assets/theme-dark/components/form/inputBase";
import menu from "app/assets/theme-dark/components/menu";
import menuItem from "app/assets/theme-dark/components/menu/menuItem";
import switchButton from "app/assets/theme-dark/components/form/switchButton";
import divider from "app/assets/theme-dark/components/divider";
import tableContainer from "app/assets/theme-dark/components/table/tableContainer";
import tableHead from "app/assets/theme-dark/components/table/tableHead";
import tableCell from "app/assets/theme-dark/components/table/tableCell";
import linearProgress from "app/assets/theme-dark/components/linearProgress";
import breadcrumbs from "app/assets/theme-dark/components/breadcrumbs";
import slider from "app/assets/theme-dark/components/slider";
import avatar from "app/assets/theme-dark/components/avatar";
import tooltip from "app/assets/theme-dark/components/tooltip";
import appBar from "app/assets/theme-dark/components/appBar";
import tabs from "app/assets/theme-dark/components/tabs";
import tab from "app/assets/theme-dark/components/tabs/tab";
import stepper from "app/assets/theme-dark/components/stepper";
import step from "app/assets/theme-dark/components/stepper/step";
import stepConnector from "app/assets/theme-dark/components/stepper/stepConnector";
import stepLabel from "app/assets/theme-dark/components/stepper/stepLabel";
import stepIcon from "app/assets/theme-dark/components/stepper/stepIcon";
import select from "app/assets/theme-dark/components/form/select";
import formControlLabel from "app/assets/theme-dark/components/form/formControlLabel";
import formLabel from "app/assets/theme-dark/components/form/formLabel";
import checkbox from "app/assets/theme-dark/components/form/checkbox";
import radio from "app/assets/theme-dark/components/form/radio";
import autocomplete from "app/assets/theme-dark/components/form/autocomplete";
import input from "app/assets/theme-dark/components/form/input";
import container from "app/assets/theme-dark/components/container";
import popover from "app/assets/theme-dark/components/popover";
import buttonBase from "app/assets/theme-dark/components/buttonBase";
import icon from "app/assets/theme-dark/components/icon";
import svgIcon from "app/assets/theme-dark/components/svgIcon";
import link from "app/assets/theme-dark/components/link";
import dialog from "app/assets/theme-dark/components/dialog";
import dialogTitle from "app/assets/theme-dark/components/dialog/dialogTitle";
import dialogContent from "app/assets/theme-dark/components/dialog/dialogContent";
import dialogContentText from "app/assets/theme-dark/components/dialog/dialogContentText";
import dialogActions from "app/assets/theme-dark/components/dialog/dialogActions";

export default createTheme({
    breakpoints: {...breakpoints},
    palette: {...colors},
    typography: {...typography},
    boxShadows: {...boxShadows},
    borders: {...borders},
    functions: {
        boxShadow,
        hexToRgb,
        linearGradient,
        pxToRem,
        rgba,
    },

    components: {
        MuiCssBaseline: {
            styleOverrides: {
                ...globals,
                ...container,
            },
        },
        MuiDrawer: {...sidenav},
        MuiList: {...list},
        MuiListItem: {...listItem},
        MuiListItemText: {...listItemText},
        MuiCard: {...card},
        MuiCardMedia: {...cardMedia},
        MuiCardContent: {...cardContent},
        MuiButton: {...button},
        MuiIconButton: {...iconButton},
        MuiInputBase: {...inputBase},
        MuiMenu: {...menu},
        MuiMenuItem: {...menuItem},
        MuiSwitch: {...switchButton},
        MuiDivider: {...divider},
        MuiTableContainer: {...tableContainer},
        MuiTableHead: {...tableHead},
        MuiTableCell: {...tableCell},
        MuiLinearProgress: {...linearProgress},
        MuiBreadcrumbs: {...breadcrumbs},
        MuiSlider: {...slider},
        MuiAvatar: {...avatar},
        MuiTooltip: {...tooltip},
        MuiAppBar: {...appBar},
        MuiTabs: {...tabs},
        MuiTab: {...tab},
        MuiStepper: {...stepper},
        MuiStep: {...step},
        MuiStepConnector: {...stepConnector},
        MuiStepLabel: {...stepLabel},
        MuiStepIcon: {...stepIcon},
        MuiSelect: {...select},
        MuiFormControlLabel: {...formControlLabel},
        MuiFormLabel: {...formLabel},
        MuiCheckbox: {...checkbox},
        MuiRadio: {...radio},
        MuiAutocomplete: {...autocomplete},
        MuiInput: {...input},
        MuiOutlinedInput: {...input},
        MuiFilledInput: {...input},
        MuiPopover: {...popover},
        MuiButtonBase: {...buttonBase},
        MuiIcon: {...icon},
        MuiSvgIcon: {...svgIcon},
        MuiLink: {...link},
        MuiDialog: {...dialog},
        MuiDialogTitle: {...dialogTitle},
        MuiDialogContent: {...dialogContent},
        MuiDialogContentText: {...dialogContentText},
        MuiDialogActions: {...dialogActions},
    },
});
